import { addMessages } from '@hana/i18n';

// Khoá chuỗi chrome; dữ liệu, mã nghiệp vụ không dịch.
addMessages('vi', {
 'qc.1': 'Tạo',
 'qc.2': 'Thử lại',
 'qc.3': 'Chờ duyệt',
 'qc.4': 'Gia hạn',
 'qc.5': 'Khách hàng',
 'qc.6': 'Tuyến · CLI →',
 'qc.7': 'Chưa có giá hãng cho tuyến này',
 'qc.8': 'Gửi hỏi giá Pricing',
 'qc.9': 'Soạn đầy đủ',
 'qc.10': 'Gửi khách',
 'qc.11': 'Gửi lại',
 'qc.12': 'Tạo job',
 'qc.13': 'Mở trang soạn',
 'qc.14': 'Giá',
 'qc.15': 'Giá dưới sàn — cần [SAL-MGR] duyệt',
 'qc.16': 'Dòng báo giá',
 'qc.17': 'Phụ thu theo biểu',
 'qc.18': 'Phát sinh có thể có',
 'qc.19': 'Theo thực tế',
 'qc.20': 'Người nhận',
 'qc.21': 'Tuyến',
 'qc.22': 'Dịch vụ',
 'qc.23': 'Hãng / tàu',
 'qc.24': 'Hiệu lực đến',
 'qc.25': 'Mở',
});
addMessages('en', {
 'qc.1': 'New',
 'qc.2': 'Retry',
 'qc.3': 'Pending approval',
 'qc.4': 'Extend',
 'qc.5': 'Customer',
 'qc.6': 'Route · CLI →',
 'qc.7': 'No carrier price for this route',
 'qc.8': 'Send pricing inquiry',
 'qc.9': 'Full editor',
 'qc.10': 'Send to customer',
 'qc.11': 'Resend',
 'qc.12': 'Create job',
 'qc.13': 'Open editor',
 'qc.14': 'Price',
 'qc.15': 'Below floor price — needs [SAL-MGR] approval',
 'qc.16': 'Quote lines',
 'qc.17': 'Tariff surcharges',
 'qc.18': 'Possible extra charges',
 'qc.19': 'At actual',
 'qc.20': 'Recipient',
 'qc.21': 'Route',
 'qc.22': 'Service',
 'qc.23': 'Carrier / vessel',
 'qc.24': 'Valid until',
 'qc.25': 'Open',
});
